import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'
import { formatDateTime } from 'utils/formatDayjsDateTime'

interface DateTimeProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const DateTimeCell: FC<DateTimeProps> = ({ params, densityStyles }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {Array.isArray(params.value) ? formatDateTime(params.value[0]) : formatDateTime(params.value)}
    </Box>
  )
}
export default DateTimeCell
